import { NumberInput, type NumberInputProps } from '@homestake/shared/ui';
import { observer, use$ } from '@legendapp/state/react';
import { Group, Tooltip } from '@mantine/core';
import { InfoIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { configurationState$ } from '../../state/configuration.state';

export type BetAmountInputProps = NumberInputProps;

export const BetAmountInput = observer((props: BetAmountInputProps) => {
  const { minBet, maxBet, maxWin, currency, decimalScale, betStepAmount } =
    use$(configurationState$);
  const { t } = useTranslation();

  return (
    <NumberInput
      allowNegative={false}
      clampBehavior="blur"
      data-test-id="bet-amount-input"
      decimalScale={decimalScale}
      fixedDecimalScale
      flex={1}
      label={
        <Group data-test-id="bet-amount-input-label" gap={4}>
          {t('betAmountInput.label')}
          <Tooltip
            label={t('betAmountInput.maxWinTooltip', { maxWin, currency })}
          >
            <InfoIcon size={14} />
          </Tooltip>
        </Group>
      }
      max={maxBet}
      min={minBet}
      placeholder="0.00"
      rightSectionWidth="auto"
      step={betStepAmount}
      thousandSeparator={false}
      {...props}
    />
  );
});
